module.exports = __webpack_public_path__ + "static/commerce2x-Insights-report-5f83750ea4d4961cebcb675d087b0d73.png";